
































































import { defineComponent, ref, computed, useContext, onMounted } from '@nuxtjs/composition-api';
import TopHorizontalItems from '~/components/pages/Top/TopHorizontalItems.vue';
import TopItemCard from '~/components/pages/Top/TopItemCard.vue';
import AppCancelButton from '~/components/partials/App/AppCancelButton.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppLoader from '~/components/partials/App/AppLoader.vue';
import ProductCartSwiper from '~/components/partials/Product/ProductCartSwiper.vue';
import { useSilverEggApi } from '~/composables/silverEgg/useSilverEggApi';
import { useStore } from '~/composables/useStore';
import { SMARTPHONE, SPEC, REQUEST_NUM_LARGE, CATEGORY_ID } from '~/constants';
import { url } from '~/utils';
import { ConvertedRecommendItem } from '~/types/common/silverEgg';

export default defineComponent({
  components: {
    TopHorizontalItems,
    TopItemCard,
    AppLink,
    AppLoader,
    AppCancelButton,
    ProductCartSwiper,
  },
  setup(props, { emit }) {
    const { app } = useContext();
    const store = useStore();
    // シルバーエッグ用
    const { fetchConvertedRecommendItems } = useSilverEggApi();
    const silverEggItems = ref<ConvertedRecommendItem[]>();
    const silverEggFoodRqid = ref<string>();
    const silverEggFoodSpec = computed<string>(() =>
      isSmartPhone.value ? SPEC.CART_IN_MODAL_FOOD_SP : SPEC.CART_IN_MODAL_FOOD_PC
    );
    const silverEggRqid = ref<string>();
    const silverEggSpec = computed<string>(() => (isSmartPhone.value ? SPEC.CART_IN_MODAL_SP : SPEC.CART_IN_MODAL_PC));

    const isSmartPhone = computed<boolean>(() => app.$ua.deviceType() === SMARTPHONE);
    const shippingMessage = computed(() => {
      const { freeShippingText, shipmentFreeAmount, totalAmount } = store.state.modules.cartMessage;
      return {
        freeShippingText,
        shipmentFreeAmount,
        totalAmount,
      };
    });

    onMounted(async () => {
      const excludedItemIds = store.state.modules.cart.carts
        .map((cart) => {
          return cart.items.map((item) => item.product_code);
        })
        .flat();
      // 食品を１件取得（先頭）
      const foodRes = await fetchConvertedRecommendItems({
        spec: silverEggFoodSpec.value,
        requestNum: 1,
        productIds: excludedItemIds,
        categoryIds: CATEGORY_ID.FOOD,
      });
      silverEggFoodRqid.value = foodRes.rqid;
      // 食品以外を29件取得
      const { items, rqid } = await fetchConvertedRecommendItems({
        spec: silverEggSpec.value,
        requestNum: REQUEST_NUM_LARGE - 1,
        productIds: excludedItemIds,
        excludedCategoryIds: CATEGORY_ID.FOOD,
      });
      silverEggItems.value = foodRes.items.concat(items);
      silverEggRqid.value = rqid;
    });

    const closeModal = () => {
      emit('close');
    };

    return {
      closeModal,
      url,
      shippingMessage,
      isSmartPhone,
      silverEggItems,
      silverEggRqid,
      silverEggSpec,
      silverEggFoodRqid,
    };
  },
});
